import { openModal } from "./modal";

/**
 * Modale "Autres jeux" : les autres titres du studio, hebergés sous
 * `/games/<nom>` sur le site multi-jeux. Meme approche que dkg-farkle
 * (liens `target="_blank"`), partagee ici entre le menu d'accueil et le HUD
 * en jeu pour que les deux menus sandwich proposent la meme chose.
 */

interface StudioGame {
  path: string;
  label: string;
  icon: string;
}

const BATTLE_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 21l7-7M21 3l-7 7" />
    <path d="M3 3l7 7M21 21l-7-7" />
    <path d="M3 3l3-1M21 3l-3-1M3 21l3 1M21 21l-3 1" />
  </svg>`;

const FARKLE_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <circle cx="9" cy="9" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="15" cy="15" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none" />
  </svg>`;

const OTHELLO_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="8" />
    <path d="M12 4a8 8 0 0 0 0 16z" fill="currentColor" stroke="none" />
  </svg>`;

const CHECKERS_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <ellipse cx="12" cy="9" rx="7" ry="3.2" />
    <path d="M5 9v4c0 1.8 3.1 3.2 7 3.2s7-1.4 7-3.2V9" />
  </svg>`;

/** Le Solitaire (Klondike) : deux cartes a jouer superposees. */
const KLONDIKE_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="6" width="9" height="13" rx="1.2" transform="rotate(-10 8.5 12.5)" />
    <rect x="9" y="5" width="9" height="13" rx="1.2" />
  </svg>`;

/** Le Solitaire du Sage : plateau ovale surmonte de quelques billes. */
const PEGSOLITAIRE_ICON_SVG = `
  <svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <ellipse cx="12" cy="14.5" rx="9" ry="4" />
    <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="12" cy="8" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="15" cy="10" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="12" cy="11.3" r="1.5" fill="currentColor" stroke="none" />
  </svg>`;

/** Le jeu courant (les echecs) est volontairement absent de sa propre liste. */
const STUDIO_GAMES: readonly StudioGame[] = [
  { path: "/games/battle", label: "Battle", icon: BATTLE_ICON_SVG },
  { path: "/games/farkle", label: "Farkle", icon: FARKLE_ICON_SVG },
  { path: "/games/othello", label: "Othello", icon: OTHELLO_ICON_SVG },
  { path: "/games/checkers", label: "Dames", icon: CHECKERS_ICON_SVG },
  { path: "/games/solitaire", label: "Solitaire", icon: KLONDIKE_ICON_SVG },
  { path: "/games/pegsolitaire", label: "Solitaire du Sage", icon: PEGSOLITAIRE_ICON_SVG },
];

export function showOtherGamesModal(): void {
  const content = document.createElement("div");
  content.innerHTML = `
    <h2 class="title-display">Autres jeux</h2>
    <p class="subtitle">Les autres tables de la taverne</p>
    <div class="menu-actions">
      ${STUDIO_GAMES.map(
        (game) => `
        <a class="btn btn-ghost" href="${game.path}" target="_blank" rel="noopener noreferrer">
          <span class="ico">${game.icon}</span><span class="lbl">${game.label}</span>
        </a>`,
      ).join("")}
      <button class="btn" id="close-other-games" type="button">Fermer</button>
    </div>
  `;
  const { close } = openModal(content);
  content.querySelector<HTMLButtonElement>("#close-other-games")?.addEventListener("click", close);
}
